
// Vue
import { Component, Mixins } from 'vue-mixin-decorator';
import { Route } from 'vue-router';

// Component
import BasePage from '@/pages/BasePage.vue';

// CMS
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Tutorial, TutorialCategoryEnum } from '@/apis/cms';

import { RouteConsts } from '@/routes/route';
import { AltContents } from '@/common/alternatives';
//import orderBy from 'lodash/orderBy';

@Component
export default class TutorialsPage extends Mixins<BasePage>(BasePage) {
  private CATEGORY_MANUAL = TutorialCategoryEnum.CATEGORY_MANUAL;
  private CATEGORY_POC = TutorialCategoryEnum.CATEGORY_POC;

  private tutorials: Array<Tutorial> = [];

  private selectedTab = '';
  private keyword = '';

  async beforeRouteUpdate(to: Route, from: Route, next: any) {
    // ハッシュを見て該当記事を探す。無ければ1番目のコンテンツを表示。
    if (to.hash) {
      this.selectedTab = to.hash.slice(1);
      next();
    } else {
      this.selectedTab = this.tutorials[0].id;
      next();
    }
  }

  private async getTutorials() {
    // CMS API呼び出し
    const httpClient = await this.$cmsClient();
    // カスタムフィールド配列を使っている関係上asで型を明示した方がリーズナブル
    const tutorials = (await httpClient.tutorial
      .getTutorials(20)
      .then(res => {
        const { data } = res;
        if (data.contents.length < 1) {
          return AltContents.TutorialsResponse.contents;
        }
        return data.contents;
      })
      .catch(() => {
        return AltContents.TutorialsResponse.contents;
      })) as Tutorial[];

    return tutorials;
  }

  private goToTutorialStep(tutorialId: string, stepId: string) {
    this.$router.push({
      name: RouteConsts.TutorialStepPage,
      params: { tutorial_id: tutorialId, step_id: stepId }
    });
  }

  private goToProductDetail(productId: string) {
    this.$router.push({
      name: RouteConsts.ProductDetailPage,
      params: { product_id: productId }
    });
  }

  private isVideoFile(src: string) {
    const ext = src.split('.').pop();
    if (ext == 'mov' || ext == 'mp4') {
      return true;
    }
    return false;
  }
  private filteredTutorials(category: TutorialCategoryEnum) {
    return this.tutorials.filter(
      e => e.category[0] == category && e.title.includes(this.keyword)
    );
  }

  async created() {
    this.store.showLoader();

    // 初期表示 APIコール
    this.tutorials = await this.getTutorials();
    if (this.$route.hash !== '') {
      this.selectedTab = this.$route.hash.slice(1);
    } else {
      this.selectedTab = this.tutorials[0].id;
    }

    this.store.hideLoader();
  }
}
